<template>
  <div 
    :class="['loader-container', containerClass]"
    :style="containerStyle"
  >
    <div :class="['loader-content', `loader-${size}`]">
      <div class="loader-logo">
        <img 
          :src="logoPath" 
          alt="LiveRun Logo"
          :class="['logo-image', `logo-${size}`]"
        />
      </div>
      <div class="loader-spinner">
        <div class="spinner"></div>
      </div>
      <div v-if="showQuote" class="loader-quote">
        <p class="quote-text">{{ currentQuote.quote }}</p>
        <p class="quote-author">— {{ currentQuote.author }}</p>
        <p v-if="currentQuote.translation" class="quote-translation">{{ currentQuote.translation }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import runningQuotes from '@/data/running-quotes.json'

export default {
  name: 'Loader',
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    },
    fullPage: {
      type: Boolean,
      default: false
    },
    showQuote: {
      type: Boolean,
      default: true
    },
    centered: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentQuote: {},
      logoPath: require('@/assets/renew-logo.png')
    }
  },
  computed: {
    containerClass() {
      return {
        'loader-full-page': this.fullPage,
        'loader-inline': !this.fullPage,
        'loader-centered': this.centered
      }
    },
    containerStyle() {
      if (this.fullPage) {
        return {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh'
        }
      }
      return {}
    }
  },
  mounted() {
    this.selectRandomQuote()
  },
  methods: {
    selectRandomQuote() {
      const randomIndex = Math.floor(Math.random() * runningQuotes.length)
      this.currentQuote = runningQuotes[randomIndex]
    }
  }
}
</script>

<style scoped lang="stylus">
.loader-container
  display flex
  align-items center
  justify-content center
  background-color rgba(255, 255, 255, 0.95)
  z-index 9999

.loader-full-page
  position fixed
  top 0
  left 0
  width 100vw
  height 100vh
  background-color rgba(255, 255, 255, 0.98)

.loader-inline
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  min-height 300px
  width 100%
  background-color rgba(255, 255, 255, 0.95)

.loader-centered
  align-items center
  justify-content center

.loader-content
  display flex
  flex-direction column
  align-items center
  justify-content center
  text-align center
  padding 2rem

.loader-logo
  margin-bottom 2rem
  animation fadeIn 0.5s ease-in

.logo-image
  display block
  height auto
  opacity 0.9

.logo-small
  max-width 100px

.logo-medium
  max-width 151px

.logo-large
  max-width 200px

.loader-spinner
  margin-bottom 2rem

.spinner
  border 4px solid #f3f3f3
  border-top 4px solid #423799
  border-radius 50%
  animation spin 1s linear infinite
  margin 0 auto

.loader-small .spinner
  width 30px
  height 30px
  border-width 3px

.loader-medium .spinner
  width 50px
  height 50px
  border-width 4px

.loader-large .spinner
  width 70px
  height 70px
  border-width 5px

.loader-quote
  max-width 600px
  margin-top 1rem
  animation fadeIn 0.8s ease-in

.quote-text
  font-size 1rem
  line-height 1.6
  color #333
  margin-bottom 0.5rem
  font-style italic

.quote-author
  font-size 0.875rem
  color #666
  margin-bottom 0.25rem
  font-weight 500

.quote-translation
  font-size 0.75rem
  color #999
  margin-top 0.5rem
  font-style normal

.loader-small .quote-text
  font-size 0.875rem

.loader-small .quote-author
  font-size 0.75rem

.loader-small .quote-translation
  font-size 0.6875rem

.loader-large .quote-text
  font-size 1.125rem

.loader-large .quote-author
  font-size 1rem

.loader-large .quote-translation
  font-size 0.875rem

@keyframes spin
  0%
    transform rotate(0deg)
  100%
    transform rotate(360deg)

@keyframes fadeIn
  from
    opacity 0
  to
    opacity 1
</style>




// WEBPACK FOOTER //
// Loader.vue?d1c68d8a